import { useEffect, useState } from "react";
import { Users } from "lucide-react";
import api from "@/lib/api";
import { money, StatusBadge } from "@/components/admin/AdminLayout";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export default function Customers() {
  const [customers, setCustomers] = useState([]);
  const [detail, setDetail] = useState(null);

  useEffect(() => { api.get("/admin/customers").then((r) => setCustomers(r.data)); }, []);

  const open = async (id) => {
    const { data } = await api.get(`/admin/customers/${id}`);
    setDetail(data);
  };

  return (
    <div className="space-y-5">
      <div><h1 className="font-display text-2xl font-bold tracking-tight">Customers</h1><p className="text-sm text-zinc-500">{customers.length} registered customers</p></div>

      {customers.length === 0 ? (
        <div className="bg-white border border-zinc-200 rounded-xl p-16 text-center text-zinc-400">
          <Users size={40} className="mx-auto mb-3" /><p className="text-sm">No registered customers yet. Guest orders appear under Orders.</p>
        </div>
      ) : (
        <div className="bg-white border border-zinc-200 rounded-xl overflow-hidden">
          <table className="w-full text-sm">
            <thead><tr className="text-left text-xs text-zinc-500 bg-zinc-50 border-b border-zinc-200">
              <th className="p-3 font-medium">Name</th><th className="p-3 font-medium">Email</th>
              <th className="p-3 font-medium">Phone</th><th className="p-3 font-medium">Orders</th>
              <th className="p-3 font-medium">Total Spent</th><th className="p-3 font-medium">Status</th>
            </tr></thead>
            <tbody>
              {customers.map((c) => (
                <tr key={c.id} onClick={() => open(c.id)} className="border-b border-zinc-50 hover:bg-zinc-50 cursor-pointer" data-testid={`customer-${c.id}`}>
                  <td className="p-3 font-medium">{c.name}</td>
                  <td className="p-3 text-zinc-600">{c.email}</td>
                  <td className="p-3 text-zinc-500">{c.phone || "—"}</td>
                  <td className="p-3">{c.orders_count}</td>
                  <td className="p-3 font-medium">{money(c.total_spent)}</td>
                  <td className="p-3"><StatusBadge status={c.status} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <Dialog open={!!detail} onOpenChange={(o) => !o && setDetail(null)}>
        <DialogContent className="max-w-lg">
          <DialogHeader><DialogTitle>{detail?.name}</DialogTitle></DialogHeader>
          {detail && (
            <div className="space-y-4 text-sm">
              <div className="grid grid-cols-3 gap-3">
                <div className="bg-zinc-50 rounded-lg p-3"><p className="text-xs text-zinc-500">Total Spent</p><p className="font-bold">{money(detail.total_spent)}</p></div>
                <div className="bg-zinc-50 rounded-lg p-3"><p className="text-xs text-zinc-500">AOV</p><p className="font-bold">{money(detail.aov)}</p></div>
                <div className="bg-zinc-50 rounded-lg p-3"><p className="text-xs text-zinc-500">Returns</p><p className="font-bold">{detail.returns_count}</p></div>
              </div>
              <div className="text-xs text-zinc-500">{detail.email} · {detail.phone || "no phone"}</div>
              <div>
                <p className="font-semibold text-xs mb-2">Orders ({detail.orders.length})</p>
                <div className="space-y-1.5 max-h-60 overflow-auto">
                  {detail.orders.map((o) => (
                    <div key={o.id} className="flex justify-between items-center text-xs border-b border-zinc-50 py-1.5">
                      <span className="font-mono">{o.order_number}</span><StatusBadge status={o.status} /><span className="font-medium">{money(o.total)}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}
